import { FC, ReactNode } from 'react'

const buttonStyles = {
  primary:
    'bg-primaryBlue enabled:hover:bg-tagBlue text-white enabled:active:bg-primaryBlueActive',
  secondary:
    'bg-secondaryGrey text-darkBlack hover:bg-secondaryGreyHover enabled:active:bg-secondaryGreyActive',
  warning: 'bg-warningRed text-white enabled:active:bg-warningRedActive',
  primaryDisabled: 'bg-secondaryGrey text-grey',
}

const buttonPadding = {
  sm: 'py-0.5 px-2', // 2px 8px
  lg: 'py-[6px] px-4', // 6px 16px
  sqsm: 'p-[5px]',
  sq: 'p-[9px]',
}

export type ActionButtonProps = {
  onClick?: () => void
  children: ReactNode
  styles?: string // for escape hatch styling
  ariaLabel: string
  type: 'primary' | 'secondary' | 'warning' | 'primaryDisabled'
  padding: 'sm' | 'lg' | 'sq' | 'sqsm'
  disabled?: boolean
  htmlButtonType?: 'submit' | 'reset' | 'button'
}

const ActionButton: FC<ActionButtonProps> = ({
  onClick,
  ariaLabel,
  styles,
  children,
  type = 'primary',
  padding = 'sm',
  disabled = false,
  htmlButtonType = 'button',
}) => {
  return (
    <button
      aria-label={ariaLabel}
      className={`${buttonStyles[type]} ${buttonPadding[padding]} rounded-lg
      ${disabled ? 'cursor-not-allowed' : ''} 
      ${styles ? styles : ''}`}
      onClick={onClick}
      disabled={disabled}
      type={htmlButtonType}
    >
      {children}
    </button>
  )
}

export default ActionButton
